"use strict";
/* tslint:disable */
var redux_1 = require("redux");
// import {composeWithDevTools} from 'remote-redux-devtools'
var redux_thunk_1 = require("redux-thunk");
var redux_logger_1 = require("redux-logger");
var reducers_1 = require("../reducers");
var epics_1 = require("../epics");
var redux_observable_1 = require("redux-observable");
var resultsMiddleWare_1 = require("../reducers/external/resultsMiddleWare");
var logger_1 = require("../logger");
var logger = redux_logger_1.createLogger({
    level: 'info',
    collapsed: true,
    predicate: function () { return logger_1.Log.getLevel() !== logger_1.LogLevel.SILENT; },
    logger: logger_1.Log
});
var epicMiddleware = redux_observable_1.createEpicMiddleware();
/* eslint-enable no-underscore-dangle */
var enhancer = redux_1.compose(redux_1.applyMiddleware(redux_thunk_1.default, logger, epicMiddleware, resultsMiddleWare_1.internalMiddleWare));
module.exports = {
    configureStore: function (initialState) {
        var store = redux_1.createStore(reducers_1.default, enhancer);
        epicMiddleware.run(epics_1.default);
        return store;
    }
};
//# sourceMappingURL=configureStore.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/store/configureStore.js
 ** module id = 2091
 ** module chunks = 0
 **/